import styled from '@emotion/styled';
import { Stack } from '@hotjar/hotsauce';

export const Settings = styled(Stack)`
  max-width: 600px;
`;

export const Preview = styled(Stack)`
  max-width: 600px;
`;
